import { protectedResources } from "../../authConfig";
import { unregisteredUser } from "../../utils/errorHandler";
import axios from "axios";
import { getAuth } from "../api/auth";
import { msalInstance } from "../../index";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  async (config) => {
    const activeAccount = msalInstance.getActiveAccount();
    const accounts = msalInstance.getAllAccounts();
    if (!activeAccount && accounts.length === 0) {
      throw new Error("No active account");
    }
    let tokenCheck = localStorage.getItem("token");
    if (!tokenCheck) {
      const authResponse = await msalInstance.acquireTokenSilent({
        scopes: protectedResources.authAPI.scopes,
        account: activeAccount || accounts[0],
      });
      localStorage.setItem("token", authResponse.accessToken);
      tokenCheck = authResponse.accessToken;
    }
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user && tokenCheck) {
      const authNew = await getAuth(tokenCheck);
      localStorage.setItem("user", JSON.stringify(authNew));
      if (!authNew.is_active) throw unregisteredUser(authNew.name);
      config.headers = {
        Authorization: `Bearer ${tokenCheck}`,
      };
      return config;
    }
    if (!user.is_active) throw unregisteredUser(user.name);
    config.headers = {
      Authorization: `Bearer ${tokenCheck}`,
    };
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    if (error?.response?.status === 401) {
      msalInstance.logoutRedirect();
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("superset_access_token");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
